var map = {
	"./ar/cold_book": [
		96118,
		6118
	],
	"./ar/cold_book.json": [
		96118,
		6118
	],
	"./ar/coldware_chat": [
		22742,
		2742
	],
	"./ar/coldware_chat.json": [
		22742,
		2742
	],
	"./ar/coldware_defi": [
		83266,
		3266
	],
	"./ar/coldware_defi.json": [
		83266,
		3266
	],
	"./ar/coldware_dvpn": [
		48939,
		8939
	],
	"./ar/coldware_dvpn.json": [
		48939,
		8939
	],
	"./ar/coldware_finance": [
		30706,
		706
	],
	"./ar/coldware_finance.json": [
		30706,
		706
	],
	"./ar/coldware_mint": [
		69094,
		9094
	],
	"./ar/coldware_mint.json": [
		69094,
		9094
	],
	"./ar/coldware_wallet": [
		28915,
		8915
	],
	"./ar/coldware_wallet.json": [
		28915,
		8915
	],
	"./ar/common": [
		11111,
		1111
	],
	"./ar/common.json": [
		11111,
		1111
	],
	"./ar/dapps": [
		90055,
		55
	],
	"./ar/dapps.json": [
		90055,
		55
	],
	"./ar/faqs": [
		25023,
		5023
	],
	"./ar/faqs.json": [
		25023,
		5023
	],
	"./ar/home": [
		50609,
		609
	],
	"./ar/home.json": [
		50609,
		609
	],
	"./ar/how_to_buy": [
		16098,
		6098
	],
	"./ar/how_to_buy.json": [
		16098,
		6098
	],
	"./ar/larna": [
		56068,
		6068
	],
	"./ar/larna.json": [
		56068,
		6068
	],
	"./ar/media_kit": [
		34934,
		4934
	],
	"./ar/media_kit.json": [
		34934,
		4934
	],
	"./ar/our_vision": [
		65179,
		5179
	],
	"./ar/our_vision.json": [
		65179,
		5179
	],
	"./ar/privacy": [
		40556,
		556
	],
	"./ar/privacy.json": [
		40556,
		556
	],
	"./ar/roadmap": [
		44365,
		4365
	],
	"./ar/roadmap.json": [
		44365,
		4365
	],
	"./ar/team": [
		24636,
		4636
	],
	"./ar/team.json": [
		24636,
		4636
	],
	"./ar/terms": [
		58783,
		8783
	],
	"./ar/terms.json": [
		58783,
		8783
	],
	"./ar/tokenomics": [
		16074,
		6074
	],
	"./ar/tokenomics.json": [
		16074,
		6074
	],
	"./de/cold_book": [
		12637,
		2637
	],
	"./de/cold_book.json": [
		12637,
		2637
	],
	"./de/coldware_chat": [
		87547,
		7547
	],
	"./de/coldware_chat.json": [
		87547,
		7547
	],
	"./de/coldware_defi": [
		61220,
		1220
	],
	"./de/coldware_defi.json": [
		61220,
		1220
	],
	"./de/coldware_dvpn": [
		86999,
		6999
	],
	"./de/coldware_dvpn.json": [
		86999,
		6999
	],
	"./de/coldware_finance": [
		95607,
		5607
	],
	"./de/coldware_finance.json": [
		95607,
		5607
	],
	"./de/coldware_mint": [
		32590,
		2590
	],
	"./de/coldware_mint.json": [
		32590,
		2590
	],
	"./de/coldware_wallet": [
		95362,
		5362
	],
	"./de/coldware_wallet.json": [
		95362,
		5362
	],
	"./de/common": [
		21545,
		1545
	],
	"./de/common.json": [
		21545,
		1545
	],
	"./de/dapps": [
		49713,
		9713
	],
	"./de/dapps.json": [
		49713,
		9713
	],
	"./de/faqs": [
		59204,
		9204
	],
	"./de/faqs.json": [
		59204,
		9204
	],
	"./de/home": [
		18948,
		8948
	],
	"./de/home.json": [
		18948,
		8948
	],
	"./de/how_to_buy": [
		38605,
		8605
	],
	"./de/how_to_buy.json": [
		38605,
		8605
	],
	"./de/larna": [
		28755,
		8755
	],
	"./de/larna.json": [
		28755,
		8755
	],
	"./de/media_kit": [
		31344,
		1344
	],
	"./de/media_kit.json": [
		31344,
		1344
	],
	"./de/our_vision": [
		43992,
		3992
	],
	"./de/our_vision.json": [
		43992,
		3992
	],
	"./de/privacy": [
		86665,
		6665
	],
	"./de/privacy.json": [
		86665,
		6665
	],
	"./de/roadmap": [
		3286,
		3286
	],
	"./de/roadmap.json": [
		3286,
		3286
	],
	"./de/team": [
		3778,
		3778
	],
	"./de/team.json": [
		3778,
		3778
	],
	"./de/terms": [
		69179,
		9179
	],
	"./de/terms.json": [
		69179,
		9179
	],
	"./de/tokenomics": [
		75104,
		5104
	],
	"./de/tokenomics.json": [
		75104,
		5104
	],
	"./en/cold_book": [
		57644,
		7644
	],
	"./en/cold_book.json": [
		57644,
		7644
	],
	"./en/coldware_chat": [
		2785,
		2785
	],
	"./en/coldware_chat.json": [
		2785,
		2785
	],
	"./en/coldware_defi": [
		4758,
		4758
	],
	"./en/coldware_defi.json": [
		4758,
		4758
	],
	"./en/coldware_dvpn": [
		3471,
		3471
	],
	"./en/coldware_dvpn.json": [
		3471,
		3471
	],
	"./en/coldware_finance": [
		88775,
		8775
	],
	"./en/coldware_finance.json": [
		88775,
		8775
	],
	"./en/coldware_mint": [
		97522,
		7522
	],
	"./en/coldware_mint.json": [
		97522,
		7522
	],
	"./en/coldware_wallet": [
		7193,
		7193
	],
	"./en/coldware_wallet.json": [
		7193,
		7193
	],
	"./en/common": [
		40464,
		464
	],
	"./en/common.json": [
		40464,
		464
	],
	"./en/dapps": [
		34822,
		4822
	],
	"./en/dapps.json": [
		34822,
		4822
	],
	"./en/faqs": [
		29529,
		9529
	],
	"./en/faqs.json": [
		29529,
		9529
	],
	"./en/home": [
		12482,
		2482
	],
	"./en/home.json": [
		12482,
		2482
	],
	"./en/how_to_buy": [
		65279,
		5279
	],
	"./en/how_to_buy.json": [
		65279,
		5279
	],
	"./en/larna": [
		1167,
		1167
	],
	"./en/larna.json": [
		1167,
		1167
	],
	"./en/media_kit": [
		69604,
		9604
	],
	"./en/media_kit.json": [
		69604,
		9604
	],
	"./en/our_vision": [
		34358,
		4358
	],
	"./en/our_vision.json": [
		34358,
		4358
	],
	"./en/privacy": [
		2297,
		2297
	],
	"./en/privacy.json": [
		2297,
		2297
	],
	"./en/roadmap": [
		63374,
		4881
	],
	"./en/roadmap.json": [
		63374,
		4881
	],
	"./en/team": [
		18022,
		8022
	],
	"./en/team.json": [
		18022,
		8022
	],
	"./en/terms": [
		4977,
		4977
	],
	"./en/terms.json": [
		4977,
		4977
	],
	"./en/tokenomics": [
		5993,
		5993
	],
	"./en/tokenomics.json": [
		5993,
		5993
	],
	"./es/cold_book": [
		75144,
		5144
	],
	"./es/cold_book.json": [
		75144,
		5144
	],
	"./es/coldware_chat": [
		88869,
		8869
	],
	"./es/coldware_chat.json": [
		88869,
		8869
	],
	"./es/coldware_defi": [
		35461,
		5461
	],
	"./es/coldware_defi.json": [
		35461,
		5461
	],
	"./es/coldware_dvpn": [
		21244,
		1244
	],
	"./es/coldware_dvpn.json": [
		21244,
		1244
	],
	"./es/coldware_finance": [
		58388,
		8388
	],
	"./es/coldware_finance.json": [
		58388,
		8388
	],
	"./es/coldware_mint": [
		84656,
		4656
	],
	"./es/coldware_mint.json": [
		84656,
		4656
	],
	"./es/coldware_wallet": [
		16225,
		6225
	],
	"./es/coldware_wallet.json": [
		16225,
		6225
	],
	"./es/common": [
		10357,
		357
	],
	"./es/common.json": [
		10357,
		357
	],
	"./es/dapps": [
		89212,
		9212
	],
	"./es/dapps.json": [
		89212,
		9212
	],
	"./es/faqs": [
		46377,
		6377
	],
	"./es/faqs.json": [
		46377,
		6377
	],
	"./es/home": [
		76891,
		6891
	],
	"./es/home.json": [
		76891,
		6891
	],
	"./es/how_to_buy": [
		51734,
		1734
	],
	"./es/how_to_buy.json": [
		51734,
		1734
	],
	"./es/larna": [
		84800,
		4800
	],
	"./es/larna.json": [
		84800,
		4800
	],
	"./es/media_kit": [
		23264,
		3264
	],
	"./es/media_kit.json": [
		23264,
		3264
	],
	"./es/our_vision": [
		64971,
		4971
	],
	"./es/our_vision.json": [
		64971,
		4971
	],
	"./es/privacy": [
		63298,
		3298
	],
	"./es/privacy.json": [
		63298,
		3298
	],
	"./es/roadmap": [
		44305,
		4305
	],
	"./es/roadmap.json": [
		44305,
		4305
	],
	"./es/team": [
		85257,
		5257
	],
	"./es/team.json": [
		85257,
		5257
	],
	"./es/terms": [
		62098,
		2098
	],
	"./es/terms.json": [
		62098,
		2098
	],
	"./es/tokenomics": [
		86386,
		6386
	],
	"./es/tokenomics.json": [
		86386,
		6386
	],
	"./fr/cold_book": [
		92499,
		2499
	],
	"./fr/cold_book.json": [
		92499,
		2499
	],
	"./fr/coldware_chat": [
		8582,
		8582
	],
	"./fr/coldware_chat.json": [
		8582,
		8582
	],
	"./fr/coldware_defi": [
		63142,
		3142
	],
	"./fr/coldware_defi.json": [
		63142,
		3142
	],
	"./fr/coldware_dvpn": [
		41614,
		1614
	],
	"./fr/coldware_dvpn.json": [
		41614,
		1614
	],
	"./fr/coldware_finance": [
		61622,
		1622
	],
	"./fr/coldware_finance.json": [
		61622,
		1622
	],
	"./fr/coldware_mint": [
		7888,
		7888
	],
	"./fr/coldware_mint.json": [
		7888,
		7888
	],
	"./fr/coldware_wallet": [
		20366,
		366
	],
	"./fr/coldware_wallet.json": [
		20366,
		366
	],
	"./fr/common": [
		45167,
		5167
	],
	"./fr/common.json": [
		45167,
		5167
	],
	"./fr/dapps": [
		40686,
		686
	],
	"./fr/dapps.json": [
		40686,
		686
	],
	"./fr/faqs": [
		20862,
		862
	],
	"./fr/faqs.json": [
		20862,
		862
	],
	"./fr/home": [
		31660,
		1660
	],
	"./fr/home.json": [
		31660,
		1660
	],
	"./fr/how_to_buy": [
		60621,
		621
	],
	"./fr/how_to_buy.json": [
		60621,
		621
	],
	"./fr/larna": [
		34089,
		4089
	],
	"./fr/larna.json": [
		34089,
		4089
	],
	"./fr/media_kit": [
		8390,
		8390
	],
	"./fr/media_kit.json": [
		8390,
		8390
	],
	"./fr/our_vision": [
		2197,
		2197
	],
	"./fr/our_vision.json": [
		2197,
		2197
	],
	"./fr/privacy": [
		26906,
		6906
	],
	"./fr/privacy.json": [
		26906,
		6906
	],
	"./fr/roadmap": [
		13374,
		3374
	],
	"./fr/roadmap.json": [
		13374,
		3374
	],
	"./fr/team": [
		63028,
		3028
	],
	"./fr/team.json": [
		63028,
		3028
	],
	"./fr/terms": [
		77667,
		7667
	],
	"./fr/terms.json": [
		77667,
		7667
	],
	"./fr/tokenomics": [
		58045,
		8045
	],
	"./fr/tokenomics.json": [
		58045,
		8045
	],
	"./id/cold_book": [
		89805,
		9805
	],
	"./id/cold_book.json": [
		89805,
		9805
	],
	"./id/coldware_chat": [
		27195,
		8380
	],
	"./id/coldware_chat.json": [
		27195,
		8380
	],
	"./id/coldware_defi": [
		53861,
		3861
	],
	"./id/coldware_defi.json": [
		53861,
		3861
	],
	"./id/coldware_dvpn": [
		14231,
		4231
	],
	"./id/coldware_dvpn.json": [
		14231,
		4231
	],
	"./id/coldware_finance": [
		12921,
		7195
	],
	"./id/coldware_finance.json": [
		12921,
		7195
	],
	"./id/coldware_mint": [
		41383,
		1383
	],
	"./id/coldware_mint.json": [
		41383,
		1383
	],
	"./id/coldware_wallet": [
		41021,
		1021
	],
	"./id/coldware_wallet.json": [
		41021,
		1021
	],
	"./id/common": [
		81610,
		1610
	],
	"./id/common.json": [
		81610,
		1610
	],
	"./id/dapps": [
		17820,
		7820
	],
	"./id/dapps.json": [
		17820,
		7820
	],
	"./id/faqs": [
		76967,
		6967
	],
	"./id/faqs.json": [
		76967,
		6967
	],
	"./id/home": [
		96903,
		6903
	],
	"./id/home.json": [
		96903,
		6903
	],
	"./id/how_to_buy": [
		96905,
		6905
	],
	"./id/how_to_buy.json": [
		96905,
		6905
	],
	"./id/larna": [
		45107,
		5107
	],
	"./id/larna.json": [
		45107,
		5107
	],
	"./id/media_kit": [
		32073,
		2073
	],
	"./id/media_kit.json": [
		32073,
		2073
	],
	"./id/our_vision": [
		38039,
		8039
	],
	"./id/our_vision.json": [
		38039,
		8039
	],
	"./id/privacy": [
		10399,
		399
	],
	"./id/privacy.json": [
		10399,
		399
	],
	"./id/roadmap": [
		43232,
		3232
	],
	"./id/roadmap.json": [
		43232,
		3232
	],
	"./id/team": [
		61264,
		1264
	],
	"./id/team.json": [
		61264,
		1264
	],
	"./id/terms": [
		58574,
		8574
	],
	"./id/terms.json": [
		58574,
		8574
	],
	"./id/tokenomics": [
		96380,
		6380
	],
	"./id/tokenomics.json": [
		96380,
		6380
	],
	"./it/cold_book": [
		89788,
		9788
	],
	"./it/cold_book.json": [
		89788,
		9788
	],
	"./it/coldware_chat": [
		82303,
		2303
	],
	"./it/coldware_chat.json": [
		82303,
		2303
	],
	"./it/coldware_defi": [
		15223,
		5223
	],
	"./it/coldware_defi.json": [
		15223,
		5223
	],
	"./it/coldware_dvpn": [
		6774,
		6774
	],
	"./it/coldware_dvpn.json": [
		6774,
		6774
	],
	"./it/coldware_finance": [
		45789,
		5789
	],
	"./it/coldware_finance.json": [
		45789,
		5789
	],
	"./it/coldware_mint": [
		10525,
		525
	],
	"./it/coldware_mint.json": [
		10525,
		525
	],
	"./it/coldware_wallet": [
		56215,
		6215
	],
	"./it/coldware_wallet.json": [
		56215,
		6215
	],
	"./it/common": [
		9486,
		9486
	],
	"./it/common.json": [
		9486,
		9486
	],
	"./it/dapps": [
		4475,
		4475
	],
	"./it/dapps.json": [
		4475,
		4475
	],
	"./it/faqs": [
		88865,
		8865
	],
	"./it/faqs.json": [
		88865,
		8865
	],
	"./it/home": [
		53765,
		3765
	],
	"./it/home.json": [
		53765,
		3765
	],
	"./it/how_to_buy": [
		78268,
		8268
	],
	"./it/how_to_buy.json": [
		78268,
		8268
	],
	"./it/larna": [
		50577,
		577
	],
	"./it/larna.json": [
		50577,
		577
	],
	"./it/media_kit": [
		53325,
		3325
	],
	"./it/media_kit.json": [
		53325,
		3325
	],
	"./it/our_vision": [
		66389,
		6389
	],
	"./it/our_vision.json": [
		66389,
		6389
	],
	"./it/privacy": [
		94987,
		4987
	],
	"./it/privacy.json": [
		94987,
		4987
	],
	"./it/roadmap": [
		76390,
		6390
	],
	"./it/roadmap.json": [
		76390,
		6390
	],
	"./it/team": [
		67000,
		7000
	],
	"./it/team.json": [
		67000,
		7000
	],
	"./it/terms": [
		2077,
		2077
	],
	"./it/terms.json": [
		2077,
		2077
	],
	"./it/tokenomics": [
		37772,
		7772
	],
	"./it/tokenomics.json": [
		37772,
		7772
	],
	"./ja/cold_book": [
		9743,
		9743
	],
	"./ja/cold_book.json": [
		9743,
		9743
	],
	"./ja/coldware_chat": [
		23077,
		3077
	],
	"./ja/coldware_chat.json": [
		23077,
		3077
	],
	"./ja/coldware_defi": [
		55353,
		5353
	],
	"./ja/coldware_defi.json": [
		55353,
		5353
	],
	"./ja/coldware_dvpn": [
		3116,
		3116
	],
	"./ja/coldware_dvpn.json": [
		3116,
		3116
	],
	"./ja/coldware_finance": [
		69901,
		9901
	],
	"./ja/coldware_finance.json": [
		69901,
		9901
	],
	"./ja/coldware_mint": [
		25103,
		5103
	],
	"./ja/coldware_mint.json": [
		25103,
		5103
	],
	"./ja/coldware_wallet": [
		21354,
		1354
	],
	"./ja/coldware_wallet.json": [
		21354,
		1354
	],
	"./ja/common": [
		20459,
		459
	],
	"./ja/common.json": [
		20459,
		459
	],
	"./ja/dapps": [
		14000,
		4000
	],
	"./ja/dapps.json": [
		14000,
		4000
	],
	"./ja/faqs": [
		77528,
		7528
	],
	"./ja/faqs.json": [
		77528,
		7528
	],
	"./ja/home": [
		68769,
		8769
	],
	"./ja/home.json": [
		68769,
		8769
	],
	"./ja/how_to_buy": [
		18126,
		8126
	],
	"./ja/how_to_buy.json": [
		18126,
		8126
	],
	"./ja/larna": [
		65040,
		5040
	],
	"./ja/larna.json": [
		65040,
		5040
	],
	"./ja/media_kit": [
		66520,
		6520
	],
	"./ja/media_kit.json": [
		66520,
		6520
	],
	"./ja/our_vision": [
		26545,
		6545
	],
	"./ja/our_vision.json": [
		26545,
		6545
	],
	"./ja/privacy": [
		12376,
		2376
	],
	"./ja/privacy.json": [
		12376,
		2376
	],
	"./ja/roadmap": [
		43530,
		3530
	],
	"./ja/roadmap.json": [
		43530,
		3530
	],
	"./ja/team": [
		61969,
		1969
	],
	"./ja/team.json": [
		61969,
		1969
	],
	"./ja/terms": [
		52559,
		2559
	],
	"./ja/terms.json": [
		52559,
		2559
	],
	"./ja/tokenomics": [
		85477,
		5477
	],
	"./ja/tokenomics.json": [
		85477,
		5477
	],
	"./ko/cold_book": [
		12191,
		2191
	],
	"./ko/cold_book.json": [
		12191,
		2191
	],
	"./ko/coldware_chat": [
		44787,
		4787
	],
	"./ko/coldware_chat.json": [
		44787,
		4787
	],
	"./ko/coldware_defi": [
		82661,
		2661
	],
	"./ko/coldware_defi.json": [
		82661,
		2661
	],
	"./ko/coldware_dvpn": [
		21415,
		1415
	],
	"./ko/coldware_dvpn.json": [
		21415,
		1415
	],
	"./ko/coldware_finance": [
		6438,
		6438
	],
	"./ko/coldware_finance.json": [
		6438,
		6438
	],
	"./ko/coldware_mint": [
		76956,
		6956
	],
	"./ko/coldware_mint.json": [
		76956,
		6956
	],
	"./ko/coldware_wallet": [
		60668,
		668
	],
	"./ko/coldware_wallet.json": [
		60668,
		668
	],
	"./ko/common": [
		95271,
		5271
	],
	"./ko/common.json": [
		95271,
		5271
	],
	"./ko/dapps": [
		45448,
		5448
	],
	"./ko/dapps.json": [
		45448,
		5448
	],
	"./ko/faqs": [
		26414,
		6414
	],
	"./ko/faqs.json": [
		26414,
		6414
	],
	"./ko/home": [
		12853,
		2853
	],
	"./ko/home.json": [
		12853,
		2853
	],
	"./ko/how_to_buy": [
		43290,
		3290
	],
	"./ko/how_to_buy.json": [
		43290,
		3290
	],
	"./ko/larna": [
		38242,
		8242
	],
	"./ko/larna.json": [
		38242,
		8242
	],
	"./ko/media_kit": [
		86322,
		6322
	],
	"./ko/media_kit.json": [
		86322,
		6322
	],
	"./ko/our_vision": [
		75150,
		5150
	],
	"./ko/our_vision.json": [
		75150,
		5150
	],
	"./ko/privacy": [
		77296,
		7296
	],
	"./ko/privacy.json": [
		77296,
		7296
	],
	"./ko/roadmap": [
		23005,
		3005
	],
	"./ko/roadmap.json": [
		23005,
		3005
	],
	"./ko/team": [
		3711,
		3711
	],
	"./ko/team.json": [
		3711,
		3711
	],
	"./ko/terms": [
		17408,
		7408
	],
	"./ko/terms.json": [
		17408,
		7408
	],
	"./ko/tokenomics": [
		8247,
		8247
	],
	"./ko/tokenomics.json": [
		8247,
		8247
	],
	"./pt/cold_book": [
		2042,
		2042
	],
	"./pt/cold_book.json": [
		2042,
		2042
	],
	"./pt/coldware_chat": [
		98045,
		8420
	],
	"./pt/coldware_chat.json": [
		98045,
		8420
	],
	"./pt/coldware_defi": [
		91682,
		1682
	],
	"./pt/coldware_defi.json": [
		91682,
		1682
	],
	"./pt/coldware_dvpn": [
		46167,
		6167
	],
	"./pt/coldware_dvpn.json": [
		46167,
		6167
	],
	"./pt/coldware_finance": [
		36876,
		6876
	],
	"./pt/coldware_finance.json": [
		36876,
		6876
	],
	"./pt/coldware_mint": [
		359,
		359
	],
	"./pt/coldware_mint.json": [
		359,
		359
	],
	"./pt/coldware_wallet": [
		49571,
		9571
	],
	"./pt/coldware_wallet.json": [
		49571,
		9571
	],
	"./pt/common": [
		41400,
		1400
	],
	"./pt/common.json": [
		41400,
		1400
	],
	"./pt/dapps": [
		35332,
		5332
	],
	"./pt/dapps.json": [
		35332,
		5332
	],
	"./pt/faqs": [
		12651,
		2651
	],
	"./pt/faqs.json": [
		12651,
		2651
	],
	"./pt/home": [
		44766,
		4766
	],
	"./pt/home.json": [
		44766,
		4766
	],
	"./pt/how_to_buy": [
		39380,
		9380
	],
	"./pt/how_to_buy.json": [
		39380,
		9380
	],
	"./pt/larna": [
		60868,
		868
	],
	"./pt/larna.json": [
		60868,
		868
	],
	"./pt/media_kit": [
		69415,
		9415
	],
	"./pt/media_kit.json": [
		69415,
		9415
	],
	"./pt/our_vision": [
		72000,
		2000
	],
	"./pt/our_vision.json": [
		72000,
		2000
	],
	"./pt/privacy": [
		25283,
		5283
	],
	"./pt/privacy.json": [
		25283,
		5283
	],
	"./pt/roadmap": [
		16375,
		6375
	],
	"./pt/roadmap.json": [
		16375,
		6375
	],
	"./pt/team": [
		68164,
		8164
	],
	"./pt/team.json": [
		68164,
		8164
	],
	"./pt/terms": [
		52801,
		2801
	],
	"./pt/terms.json": [
		52801,
		2801
	],
	"./pt/tokenomics": [
		22798,
		2798
	],
	"./pt/tokenomics.json": [
		22798,
		2798
	],
	"./ru/cold_book": [
		73552,
		3552
	],
	"./ru/cold_book.json": [
		73552,
		3552
	],
	"./ru/coldware_chat": [
		11349,
		1349
	],
	"./ru/coldware_chat.json": [
		11349,
		1349
	],
	"./ru/coldware_defi": [
		14683,
		4683
	],
	"./ru/coldware_defi.json": [
		14683,
		4683
	],
	"./ru/coldware_dvpn": [
		18160,
		8160
	],
	"./ru/coldware_dvpn.json": [
		18160,
		8160
	],
	"./ru/coldware_finance": [
		75059,
		5059
	],
	"./ru/coldware_finance.json": [
		75059,
		5059
	],
	"./ru/coldware_mint": [
		96826,
		6826
	],
	"./ru/coldware_mint.json": [
		96826,
		6826
	],
	"./ru/coldware_wallet": [
		21948,
		1948
	],
	"./ru/coldware_wallet.json": [
		21948,
		1948
	],
	"./ru/common": [
		77247,
		7247
	],
	"./ru/common.json": [
		77247,
		7247
	],
	"./ru/dapps": [
		29724,
		9724
	],
	"./ru/dapps.json": [
		29724,
		9724
	],
	"./ru/faqs": [
		33050,
		3050
	],
	"./ru/faqs.json": [
		33050,
		3050
	],
	"./ru/home": [
		32503,
		2503
	],
	"./ru/home.json": [
		32503,
		2503
	],
	"./ru/how_to_buy": [
		1422,
		1422
	],
	"./ru/how_to_buy.json": [
		1422,
		1422
	],
	"./ru/larna": [
		32386,
		2386
	],
	"./ru/larna.json": [
		32386,
		2386
	],
	"./ru/media_kit": [
		33025,
		3025
	],
	"./ru/media_kit.json": [
		33025,
		3025
	],
	"./ru/our_vision": [
		87300,
		7300
	],
	"./ru/our_vision.json": [
		87300,
		7300
	],
	"./ru/privacy": [
		28771,
		8771
	],
	"./ru/privacy.json": [
		28771,
		8771
	],
	"./ru/roadmap": [
		78445,
		8445
	],
	"./ru/roadmap.json": [
		78445,
		8445
	],
	"./ru/team": [
		58833,
		8833
	],
	"./ru/team.json": [
		58833,
		8833
	],
	"./ru/terms": [
		74312,
		4312
	],
	"./ru/terms.json": [
		74312,
		4312
	],
	"./ru/tokenomics": [
		72781,
		2781
	],
	"./ru/tokenomics.json": [
		72781,
		2781
	],
	"./th/cold_book": [
		94350,
		4350
	],
	"./th/cold_book.json": [
		94350,
		4350
	],
	"./th/coldware_chat": [
		31276,
		1276
	],
	"./th/coldware_chat.json": [
		31276,
		1276
	],
	"./th/coldware_defi": [
		3740,
		3740
	],
	"./th/coldware_defi.json": [
		3740,
		3740
	],
	"./th/coldware_dvpn": [
		14732,
		4732
	],
	"./th/coldware_dvpn.json": [
		14732,
		4732
	],
	"./th/coldware_finance": [
		57475,
		7475
	],
	"./th/coldware_finance.json": [
		57475,
		7475
	],
	"./th/coldware_mint": [
		71185,
		1185
	],
	"./th/coldware_mint.json": [
		71185,
		1185
	],
	"./th/coldware_wallet": [
		54455,
		4455
	],
	"./th/coldware_wallet.json": [
		54455,
		4455
	],
	"./th/common": [
		63303,
		3303
	],
	"./th/common.json": [
		63303,
		3303
	],
	"./th/dapps": [
		78094,
		8094
	],
	"./th/dapps.json": [
		78094,
		8094
	],
	"./th/faqs": [
		37796,
		7796
	],
	"./th/faqs.json": [
		37796,
		7796
	],
	"./th/home": [
		61686,
		1686
	],
	"./th/home.json": [
		61686,
		1686
	],
	"./th/how_to_buy": [
		65072,
		5072
	],
	"./th/how_to_buy.json": [
		65072,
		5072
	],
	"./th/larna": [
		75815,
		5815
	],
	"./th/larna.json": [
		75815,
		5815
	],
	"./th/media_kit": [
		31621,
		1621
	],
	"./th/media_kit.json": [
		31621,
		1621
	],
	"./th/our_vision": [
		18895,
		8895
	],
	"./th/our_vision.json": [
		18895,
		8895
	],
	"./th/privacy": [
		51890,
		1890
	],
	"./th/privacy.json": [
		51890,
		1890
	],
	"./th/roadmap": [
		50458,
		458
	],
	"./th/roadmap.json": [
		50458,
		458
	],
	"./th/team": [
		31201,
		1201
	],
	"./th/team.json": [
		31201,
		1201
	],
	"./th/terms": [
		10977,
		977
	],
	"./th/terms.json": [
		10977,
		977
	],
	"./th/tokenomics": [
		63678,
		3678
	],
	"./th/tokenomics.json": [
		63678,
		3678
	],
	"./tr/cold_book": [
		87166,
		7166
	],
	"./tr/cold_book.json": [
		87166,
		7166
	],
	"./tr/coldware_chat": [
		56693,
		6693
	],
	"./tr/coldware_chat.json": [
		56693,
		6693
	],
	"./tr/coldware_defi": [
		70734,
		734
	],
	"./tr/coldware_defi.json": [
		70734,
		734
	],
	"./tr/coldware_dvpn": [
		46941,
		6941
	],
	"./tr/coldware_dvpn.json": [
		46941,
		6941
	],
	"./tr/coldware_finance": [
		89475,
		9475
	],
	"./tr/coldware_finance.json": [
		89475,
		9475
	],
	"./tr/coldware_mint": [
		48249,
		8249
	],
	"./tr/coldware_mint.json": [
		48249,
		8249
	],
	"./tr/coldware_wallet": [
		96487,
		6487
	],
	"./tr/coldware_wallet.json": [
		96487,
		6487
	],
	"./tr/common": [
		72973,
		2973
	],
	"./tr/common.json": [
		72973,
		2973
	],
	"./tr/dapps": [
		63141,
		3141
	],
	"./tr/dapps.json": [
		63141,
		3141
	],
	"./tr/faqs": [
		97759,
		7759
	],
	"./tr/faqs.json": [
		97759,
		7759
	],
	"./tr/home": [
		27646,
		7646
	],
	"./tr/home.json": [
		27646,
		7646
	],
	"./tr/how_to_buy": [
		26098,
		3595
	],
	"./tr/how_to_buy.json": [
		26098,
		3595
	],
	"./tr/larna": [
		6104,
		6104
	],
	"./tr/larna.json": [
		6104,
		6104
	],
	"./tr/media_kit": [
		94440,
		4440
	],
	"./tr/media_kit.json": [
		94440,
		4440
	],
	"./tr/our_vision": [
		37890,
		7890
	],
	"./tr/our_vision.json": [
		37890,
		7890
	],
	"./tr/privacy": [
		25937,
		5937
	],
	"./tr/privacy.json": [
		25937,
		5937
	],
	"./tr/roadmap": [
		8661,
		8661
	],
	"./tr/roadmap.json": [
		8661,
		8661
	],
	"./tr/team": [
		39896,
		9896
	],
	"./tr/team.json": [
		39896,
		9896
	],
	"./tr/terms": [
		41092,
		1092
	],
	"./tr/terms.json": [
		41092,
		1092
	],
	"./tr/tokenomics": [
		56745,
		6745
	],
	"./tr/tokenomics.json": [
		56745,
		6745
	],
	"./zh/cold_book": [
		23804,
		3804
	],
	"./zh/cold_book.json": [
		23804,
		3804
	],
	"./zh/coldware_chat": [
		92513,
		2513
	],
	"./zh/coldware_chat.json": [
		92513,
		2513
	],
	"./zh/coldware_defi": [
		79252,
		9252
	],
	"./zh/coldware_defi.json": [
		79252,
		9252
	],
	"./zh/coldware_dvpn": [
		91790,
		1790
	],
	"./zh/coldware_dvpn.json": [
		91790,
		1790
	],
	"./zh/coldware_finance": [
		24200,
		4200
	],
	"./zh/coldware_finance.json": [
		24200,
		4200
	],
	"./zh/coldware_mint": [
		90669,
		669
	],
	"./zh/coldware_mint.json": [
		90669,
		669
	],
	"./zh/coldware_wallet": [
		24088,
		4088
	],
	"./zh/coldware_wallet.json": [
		24088,
		4088
	],
	"./zh/common": [
		66671,
		6671
	],
	"./zh/common.json": [
		66671,
		6671
	],
	"./zh/dapps": [
		76039,
		6039
	],
	"./zh/dapps.json": [
		76039,
		6039
	],
	"./zh/faqs": [
		11339,
		1339
	],
	"./zh/faqs.json": [
		11339,
		1339
	],
	"./zh/home": [
		93056,
		3056
	],
	"./zh/home.json": [
		93056,
		3056
	],
	"./zh/how_to_buy": [
		19624,
		9624
	],
	"./zh/how_to_buy.json": [
		19624,
		9624
	],
	"./zh/larna": [
		85173,
		5173
	],
	"./zh/larna.json": [
		85173,
		5173
	],
	"./zh/media_kit": [
		5102,
		5102
	],
	"./zh/media_kit.json": [
		5102,
		5102
	],
	"./zh/our_vision": [
		19775,
		9775
	],
	"./zh/our_vision.json": [
		19775,
		9775
	],
	"./zh/privacy": [
		94699,
		4699
	],
	"./zh/privacy.json": [
		94699,
		4699
	],
	"./zh/roadmap": [
		68377,
		8377
	],
	"./zh/roadmap.json": [
		68377,
		8377
	],
	"./zh/team": [
		32040,
		2040
	],
	"./zh/team.json": [
		32040,
		2040
	],
	"./zh/terms": [
		86382,
		6382
	],
	"./zh/terms.json": [
		86382,
		6382
	],
	"./zh/tokenomics": [
		78871,
		8871
	],
	"./zh/tokenomics.json": [
		78871,
		8871
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 30242;
module.exports = webpackAsyncContext;